module.exports = __webpack_public_path__ + "img/gfit1.8b00ec7b.jpg";